export const WHATSAPP_URL =
    "https://wa.me/256764800097?text=Hello%20Deoeditz%2C%20I%20would%20like%20to%20inquire%20about%20video%20editing%20services%20and%20filters.";
export const WHATSAPP_DISPLAY = "+256 764 800 097";

export const TIKTOK_URL = "https://www.tiktok.com/@deoeditz5";
export const TIKTOK_HANDLE = "@deoeditz5";

export const FILTERS = [
    { id: "none", name: "Original", css: null },
    {
        id: "teal_orange",
        name: "Teal & Orange",
        css: "contrast(130%) saturate(140%) hue-rotate(-15deg) sepia(20%)",
    },
    {
        id: "cyber_neon",
        name: "Cyber Neon",
        css: "contrast(150%) saturate(200%) hue-rotate(280deg) brightness(110%)",
    },
    {
        id: "vintage_super8",
        name: "Super 8",
        css: "sepia(50%) contrast(115%) brightness(95%) saturate(120%)",
    },
    {
        id: "noir_bw",
        name: "Noir B&W",
        css: "grayscale(100%) contrast(160%) brightness(90%)",
    },
    {
        id: "warm_golden",
        name: "Golden Hour",
        css: "sepia(30%) saturate(150%) brightness(105%) hue-rotate(-10deg)",
    },
    {
        id: "emerald_film",
        name: "Emerald Film",
        css: "hue-rotate(45deg) saturate(130%) contrast(120%) brightness(95%)",
    },
    {
        id: "vhs_glitch",
        name: "VHS Glitch",
        css: "contrast(140%) saturate(180%) hue-rotate(90deg) invert(10%)",
    },
    {
        id: "anamorphic_blue",
        name: "Anamorphic Blue",
        css: "contrast(125%) saturate(110%) hue-rotate(190deg) brightness(105%)",
    },
    {
        id: "amethyst",
        name: "Amethyst",
        css: "saturate(130%) contrast(115%) hue-rotate(290deg) brightness(105%)",
    },
    {
        id: "rose",
        name: "Rosé",
        css: "sepia(25%) saturate(150%) hue-rotate(-45deg) brightness(106%)",
    },
    {
        id: "arctic",
        name: "Arctic",
        css: "saturate(115%) contrast(112%) hue-rotate(170deg) brightness(104%)",
    },
    {
        id: "dust",
        name: "Dust",
        css: "sepia(45%) saturate(110%) contrast(105%) brightness(104%)",
    },
    {
        id: "moody",
        name: "Moody",
        css: "saturate(65%) contrast(135%) brightness(88%)",
    },
    {
        id: "bleach",
        name: "Bleach",
        css: "saturate(55%) contrast(175%) brightness(112%)",
    },
    {
        id: "matrix",
        name: "Matrix",
        css: "grayscale(100%) sepia(100%) hue-rotate(70deg) saturate(500%) contrast(125%)",
    },
    {
        id: "pastel",
        name: "Pastel",
        css: "saturate(60%) contrast(85%) brightness(115%)",
    },
    {
        id: "cinema_f",
        name: "Cinema",
        css: "contrast(125%) saturate(120%) hue-rotate(185deg) brightness(102%)",
    },
    {
        id: "warm_f",
        name: "Warm",
        css: "sepia(25%) saturate(135%) hue-rotate(-12deg) brightness(105%)",
    },
    {
        id: "cool_f",
        name: "Cool",
        css: "saturate(115%) hue-rotate(165deg) brightness(103%)",
    },
    {
        id: "bright_f",
        name: "Bright",
        css: "brightness(115%) saturate(105%)",
    },
    {
        id: "contrast_f",
        name: "Contrast",
        css: "contrast(160%) saturate(115%)",
    },
    {
        id: "sunset_f",
        name: "Sunset",
        css: "sepia(35%) saturate(160%) hue-rotate(-25deg) contrast(108%)",
    },
    {
        id: "neon_f",
        name: "Neon",
        css: "saturate(220%) contrast(135%) hue-rotate(300deg) brightness(105%)",
    },
    {
        id: "hdr_f",
        name: "HDR",
        css: "saturate(150%) contrast(140%) brightness(104%)",
    },
];

export const EFFECTS = [
    { id: "grain", name: "Film Grain" },
    { id: "scanlines", name: "VHS Lines" },
    { id: "letterbox", name: "Cinema Bars" },
    { id: "glow", name: "Dream Glow" },
    { id: "leak", name: "Light Leak" },
];

export const SAMPLES = [
    { id: "waves", title: "Golden Waves", url: "/samples/waves.webm" },
    { id: "city", title: "The Colorist", url: "/samples/city.webm" },
    { id: "bunny", title: "Big Buck Bunny", url: "/samples/bunny.webm" },
];

export const ASPECTS = [
    { id: "9-16", label: "9:16", hint: "Reels · TikTok", w: 720, h: 1280 },
    { id: "1-1", label: "1:1", hint: "Feed post", w: 900, h: 900 },
    { id: "16-9", label: "16:9", hint: "YouTube", w: 1280, h: 720 },
    { id: "4-5", label: "4:5", hint: "Portrait", w: 864, h: 1080 },
];

export const DEFAULT_ADJ = {
    brightness: 100,
    contrast: 100,
    saturation: 100,
    blur: 0,
    hue: 0,
    vignette: 0,
};

export function buildAdjustCss(adj) {
    const parts = [];
    if (adj.brightness !== 100) parts.push(`brightness(${adj.brightness}%)`);
    if (adj.contrast !== 100) parts.push(`contrast(${adj.contrast}%)`);
    if (adj.saturation !== 100) parts.push(`saturate(${adj.saturation}%)`);
    if (adj.blur > 0) parts.push(`blur(${adj.blur}px)`);
    if (adj.hue !== 0) parts.push(`hue-rotate(${adj.hue}deg)`);
    return parts.length ? parts.join(" ") : null;
}

export function combinedCss(preset, adj) {
    const p = preset && preset.css ? preset.css : null;
    const a = buildAdjustCss(adj || DEFAULT_ADJ);
    if (!p && !a) return null;
    return [p, a].filter(Boolean).join(" ");
}

function drawCover(ctx, video, W, H, rot) {
    const vw = video.videoWidth;
    const vh = video.videoHeight;
    if (!vw || !vh) return false;
    if (!rot) {
        const scale = Math.max(W / vw, H / vh);
        ctx.drawImage(video, (W - vw * scale) / 2, (H - vh * scale) / 2, vw * scale, vh * scale);
        return true;
    }
    ctx.save();
    ctx.translate(W / 2, H / 2);
    ctx.rotate((rot * Math.PI) / 180);
    const bw = rot % 180 === 0 ? W : H;
    const bh = rot % 180 === 0 ? H : W;
    const scale = Math.max(bw / vw, bh / vh);
    ctx.drawImage(video, (-vw * scale) / 2, (-vh * scale) / 2, vw * scale, vh * scale);
    ctx.restore();
    return true;
}

function drawVignette(ctx, W, H, strength) {
    const g = ctx.createRadialGradient(W / 2, H / 2, Math.min(W, H) * 0.35, W / 2, H / 2, Math.max(W, H) * 0.75);
    g.addColorStop(0, "rgba(0,0,0,0)");
    g.addColorStop(1, `rgba(0,0,0,${(strength / 100) * 0.85})`);
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);
}

let _noiseTiles = null;
function getNoiseTiles() {
    if (_noiseTiles) return _noiseTiles;
    const tiles = [];
    for (let i = 0; i < 3; i++) {
        const c = document.createElement("canvas");
        c.width = 160;
        c.height = 160;
        const x = c.getContext("2d");
        const img = x.createImageData(160, 160);
        for (let p = 0; p < img.data.length; p += 4) {
            const v = Math.floor(Math.random() * 255);
            img.data[p] = v;
            img.data[p + 1] = v;
            img.data[p + 2] = v;
            img.data[p + 3] = 255;
        }
        x.putImageData(img, 0, 0);
        tiles.push(c);
    }
    _noiseTiles = tiles;
    return tiles;
}

// Two-pass renderer: raw frame, then the graded frame painted over it with
// alpha = intensity. Works for every CSS filter and gives a true intensity mix.
export function drawProcessed(ctx, video, W, H, opts) {
    const { css, intensity, vignette, showOriginal, split, effects, rot } = opts || {};
    ctx.fillStyle = "#000";
    ctx.fillRect(0, 0, W, H);
    ctx.filter = "none";
    ctx.globalAlpha = 1;
    const ok = drawCover(ctx, video, W, H, rot || 0);
    if (!ok) return;

    const graded = css && intensity > 0;
    if (!showOriginal) {
        if (graded) {
            ctx.filter = css;
            ctx.globalAlpha = Math.min(1, intensity);
            drawCover(ctx, video, W, H, rot || 0);
            ctx.filter = "none";
            ctx.globalAlpha = 1;
        }
        if (vignette > 0) drawVignette(ctx, W, H, vignette);

        // split-compare: right of the divider shows the untouched frame
        if (split < 100) {
            const sx = (split / 100) * W;
            ctx.save();
            ctx.beginPath();
            ctx.rect(sx, 0, W - sx, H);
            ctx.clip();
            ctx.filter = "none";
            ctx.globalAlpha = 1;
            drawCover(ctx, video, W, H, rot || 0);
            ctx.restore();
        }
    }

    // effects stack (drawn on top, included in exports)
    const fx = effects || {};
    if (fx.glow) {
        ctx.save();
        ctx.globalCompositeOperation = "screen";
        ctx.globalAlpha = 0.38;
        ctx.filter = "blur(8px) brightness(150%)";
        drawCover(ctx, video, W, H);
        ctx.restore();
    }
    if (fx.leak) {
        ctx.save();
        ctx.globalCompositeOperation = "screen";
        const g = ctx.createRadialGradient(W * 0.9, H * 0.08, 0, W * 0.9, H * 0.08, Math.max(W, H) * 0.95);
        g.addColorStop(0, "rgba(255,120,40,0.5)");
        g.addColorStop(0.4, "rgba(255,60,0,0.18)");
        g.addColorStop(1, "rgba(255,60,0,0)");
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, W, H);
        ctx.restore();
    }
    if (fx.scanlines) {
        ctx.save();
        ctx.globalAlpha = 0.22;
        ctx.fillStyle = "#000";
        for (let y = 0; y < H; y += 4) {
            ctx.fillRect(0, y, W, 2);
        }
        ctx.restore();
    }
    if (fx.grain) {
        ctx.save();
        const tiles = getNoiseTiles();
        const tile = tiles[Math.floor(performance.now() / 90) % tiles.length];
        ctx.globalAlpha = 0.14;
        ctx.globalCompositeOperation = "overlay";
        ctx.fillStyle = ctx.createPattern(tile, "repeat");
        ctx.fillRect(0, 0, W, H);
        ctx.restore();
    }
    if (fx.letterbox) {
        ctx.save();
        ctx.filter = "none";
        ctx.globalAlpha = 1;
        ctx.fillStyle = "#000";
        const bar = Math.round(H * 0.115);
        ctx.fillRect(0, 0, W, bar);
        ctx.fillRect(0, H - bar, W, bar);
        ctx.restore();
    }
}

export function drawSplitDivider(ctx, W, H, split) {
    const x = (split / 100) * W;
    ctx.save();
    ctx.filter = "none";
    ctx.globalAlpha = 1;
    ctx.fillStyle = "rgba(255,159,28,0.95)";
    ctx.fillRect(x - 1, 0, 2, H);
    ctx.beginPath();
    ctx.arc(x, 28, 11, 0, Math.PI * 2);
    ctx.fillStyle = "#ff9f1c";
    ctx.fill();
    ctx.fillStyle = "#0b0c10";
    ctx.font = "bold 11px 'JetBrains Mono', monospace";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("<>", x, 29);
    ctx.restore();
}

export function fmtTime(t) {
    if (!isFinite(t) || t < 0) t = 0;
    const m = Math.floor(t / 60);
    const s = Math.floor(t % 60);
    const d = Math.floor((t % 1) * 10);
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}.${d}`;
}

export function pickMime() {
    if (!window.MediaRecorder) return "";
    const candidates = [
        "video/webm;codecs=vp9,opus",
        "video/webm;codecs=vp8,opus",
        "video/webm",
        "video/mp4",
    ];
    return candidates.find((m) => MediaRecorder.isTypeSupported(m)) || "";
}
